<div class="main">
    <div class="header">
      <div class="text" *ngIf="type == 'bulk'">
        {{ 'CREATE_BILLS.bulk_generate_bill' | translate}}
      </div>
      <div class="text"  *ngIf="type == 'generate'">
        {{ 'CREATE_BILLS.generate' | translate}}
      </div>
      <div  class="text" *ngIf="type == 'regenerate'">
        {{ 'CREATE_BILLS.regenerate' | translate}}
      </div>
      <i class="material-icons" (click)="closeModal();">clear</i>
    </div>
    <div class="section">
      <h2 style="font-weight: normal;" *ngIf="type == 'bulk'"> {{ 'CREATE_BILLS.bulk_dialog_text' | translate}}</h2>
      <h2 style="font-weight: normal;" *ngIf="type == 'generate'"> {{ 'CREATE_BILLS.generate_dialog_text' | translate}}</h2>
      <h2 style="font-weight: normal;" *ngIf="type == 'regenerate'"> {{ 'CREATE_BILLS.regenerate_dialog_text' | translate}}</h2>
      <div class="submitButtonYes" (click)="createBill();" >
        <div class="button" style="background-color: #73235c;">
          {{'CONFIRMMODAL.yes' | translate}}
        </div>
      </div>
      <div class="submitButtonNo" (click)="closeModal();" style="float: right;margin-right: 10px;">
        <div class="button" >
          {{'CONFIRMMODAL.no' | translate}}
        </div>
      </div>
    </div>
  </div>